<a href="javascript:;" 
    class="avatar" 
    aria-label="Account Dropdown"
    [style.background-image]="'url(' + profileImg + ')'"
    cdkMenuItem
    [cdkMenuTriggerFor]="userSettings">
</a>

<ng-template #userSettings>
    <div class="sub-menu subtle-shadow-200">
        <li cdkMenu class="sub-menu__item"
            (click)="$event.stopPropagation()">
            <ul class="sub-menu__account">
                <li class="sub-account-names">
                    <span class="names">{{ firstName }} {{ lastName }}</span>
                </li>
                <li class="sub-account-email">
                    <span class="email">{{ email }}</span>
                </li>
                <!-- Navigate to IS page -->
                <li class="sub-account-email">
                    <a class="is-link"
                        (click)="navigateToSettings()">
                        My Profile
                    </a>
                </li>
            </ul>
            <ul class="sub-menu__links">
                <li class="link">
                    <a href="javascript:;" class="link__item"
                        (click)="onLogout()">
                        <i class="icon icon-sign-out fs_20 mr_10"></i>
                        Sign Out
                    </a>
                </li>
            </ul>
        </li>
    </div>
</ng-template>
